export const replaceUploadPlaceholder = (view, placeholder, replacement) => {
    if (!view.dom.isConnected)
        return;
    const source = view.state.doc.toString();
    const from = source.indexOf(placeholder);
    if (from < 0)
        return;
    view.dispatch({
        changes: {
            from,
            to: from + placeholder.length,
            insert: replacement
        }
    });
};
